import { DatadogService } from './datadog.service';

export default angular
  .module('sfMobile.services.datadog', [])
  .service('datadogService', DatadogService).name;
